import React, { useState, useEffect } from "react";
import "./appNavbar.css";
import { NavLink, useHistory, Navigate, useNavigate } from "react-router-dom";
// import Select from "react-select";
import { FiAlignRight, FiX } from "react-icons/fi";
import { SwapLogo } from "../../Assets";
import Fade from "react-reveal/Fade";

function Navbar(props) {
  const navigate = useNavigate();
  const [isScrolling, setIsScrolling] = useState(false);
  const [isActive, setIsActive] = useState(0);
  const [toggleMenu, setToggleMenu] = useState(false);

  useEffect(() => {
    window.addEventListener("scroll", () => {
      if (window.scrollY > 0) {
        setIsScrolling(true);
        setToggleMenu(false);
      } else if (window.scrollY === 0) {
        setIsScrolling(false);
      }
    });
  });

  function scrolldiv(scroll) {
    var elem = document.getElementById(scroll);
    elem.scrollIntoView({ behavior: "smooth" });
  }
  // console.log("isScrolling", isScrolling);

  return (
    <Fade top>
      <nav
        className={
          isScrolling
            ? "NavBar_Main_Container Active_Header"
            : "NavBar_Main_Container"
        }
      >
        <img src={SwapLogo} className="Nav_Image_Style" />
        <div>
          <div className={"Navlink_Wrapper"}>
            <div
              onClick={() => {
                setIsActive(0);
                scrolldiv("Header_Section");
              }}
              style={{
                backgroundColor: isActive == 0 ? "white" : null,
                color: isActive == 0 ? "black" : "white",
              }}
              className={isScrolling ? "Link_Style_Scroll" : "Link_Style"}
            >
              Docs
            </div>
            <div
              onClick={() => {
                setIsActive(1);
                scrolldiv("Faq_Section");
              }}
              style={{
                backgroundColor: isActive == 1 ? "white" : null,
                color: isActive == 1 ? "black" : "white",
              }}
              className={isScrolling ? "Link_Style_Scroll" : "Link_Style"}
            >
              FAQs
            </div>
            <div
              onClick={() => {
                setIsActive(2);
              }}
              style={{
                backgroundColor: isActive == 2 ? "white" : null,
                color: isActive == 2 ? "black" : "white",
              }}
              className={isScrolling ? "Link_Style_Scroll" : "Link_Style"}
            >
              Launch App
            </div>
            <div
              onClick={() => {
                setIsActive(3);
                scrolldiv("Footer_Section");
              }}
              style={{
                backgroundColor: isActive == 3 ? "white" : null,
                color: isActive == 3 ? "black" : "white",
              }}
              className={isScrolling ? "Link_Style_Scroll" : "Link_Style"}
            >
              Join us
            </div>
          </div>
        </div>

        <div className={"NavLink_App_Smaller_Devices"}>
          {toggleMenu ? (
            <div className="Toggle_Btn_CLose">
              <FiX
                color="white"
                size={30}
                onClick={() => setToggleMenu(false)}
              />
            </div>
          ) : (
            <div className="Toggle_Btn_Open">
              <FiAlignRight
                color="white"
                size={30}
                onClick={() => setToggleMenu(true)}
              />
            </div>
          )}

          {toggleMenu ? (
            <div className={"NavLink_App_Smaller_Overlay"}>
              <div className={"Navlink_App_Links_Wrapper_SmallScreen_links"}>
                <div
                  className={"Link_Style_Small_Device"}
                  onClick={() => {
                    setIsActive(0);
                    scrolldiv("Header_Section");
                  }}
                  style={{
                    backgroundColor: isActive == 0 ? "#01052A" : null,
                    color: isActive == 0 ? "white" : "black",
                  }}
                >
                  Docs
                </div>
                <div
                  className={"Link_Style_Small_Device"}
                  onClick={() => {
                    setIsActive(1);
                    scrolldiv("Faq_Section");
                  }}
                  style={{
                    backgroundColor: isActive == 1 ? "#01052A" : null,
                    color: isActive == 1 ? "white" : "black",
                  }}
                >
                  FAQs
                </div>
                <div
                  className={"Link_Style_Small_Device"}
                  onClick={() => {
                    setIsActive(2);
                  }}
                  style={{
                    backgroundColor: isActive == 2 ? "#01052A" : null,
                    color: isActive == 2 ? "white" : "black",
                  }}
                >
                  Launch dApp
                </div>
                <div
                  className={"Link_Style_Small_Device"}
                  onClick={() => {
                    setIsActive(3);
                    scrolldiv("Footer_Section");
                  }}
                  style={{
                    backgroundColor: isActive == 3 ? "#01052A" : null,
                    color: isActive == 3 ? "white" : "black",
                  }}
                >
                  Join us
                </div>
              </div>
            </div>
          ) : null}
        </div>
      </nav>
    </Fade>
  );
}

export default Navbar;
